<template>
    <div class="main-panel">
        <h1>Competition</h1>
        <p>CompID: {{ competitionId }}</p>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import { useRoute } from "vue-router";

    export default defineComponent({
        setup() {
            const route = useRoute();
       
            const competitionId = route.params.competitionId.toString();  

            return { competitionId };
        },
    });
</script>
